export type AppEnvironment = 'local' | 'dev' | 'prod';

/**
 * Resolves the environment this build runs in. `VITE_APP_ENVIRONMENT` is set by the deploy pipeline
 * (`dev` or `prod`); without it, `npm run dev` is `local` and any other build is treated as `prod`.
 */
function resolveAppEnvironment(): AppEnvironment {
  const configured = import.meta.env.VITE_APP_ENVIRONMENT?.trim().toLowerCase();
  if (configured === 'local' || configured === 'dev' || configured === 'prod') {
    return configured;
  }
  return import.meta.env.DEV ? 'local' : 'prod';
}

export const appEnvironment: AppEnvironment = resolveAppEnvironment();

const appBarColors: Record<'local' | 'dev', Record<'light' | 'dark', string>> = {
  local: { light: '#f2babd', dark: '#6c272a' },
  dev: { light: '#feef9b', dark: '#76660e' },
};

/**
 * Top bar background that tells the user which environment they are in: soft red for local, soft
 * yellow for dev. Production returns `undefined` so the bar keeps its default look.
 * @param mode - 'light' or 'dark' color scheme.
 */
export function appBarEnvironmentColor(mode: 'light' | 'dark'): string | undefined {
  return appEnvironment === 'prod' ? undefined : appBarColors[appEnvironment][mode];
}
